
    var riot = require('riot')
    riot.tag2('app', '<div id="main-content"> <div class="logo"> <a target="_blank" href="https://smct.jp"> <img src="/assets/images/logo.png" alt=""> </a> </div> <main id="app-router"></main> </div> <kf-loader show="{loading}"></kf-loader> <kf-dialog show="{dialog.show}" message="{dialog.message}" status="{dialog.status}" on-close="{action.hideDialog}"></kf-dialog>', 'app,[data-is="app"]{ display: block; padding: 15px 10px; } app #main-content,[data-is="app"] #main-content{ padding: 30px 16px; -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24); box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24); border-radius: 4px; background-color: white; margin: 60px auto 0 auto; width: 500px; max-width: 100%; } app .logo,[data-is="app"] .logo{ text-align: center; } app .logo img,[data-is="app"] .logo img{ max-width: 100%; }', '', function(opts) {
    this.connect(state => ({
      loading: state.loading,
      dialog: state.dialog
    }));
});
    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('app')
    }
  }
  